import React, { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { styleBlock } from "../styleBlock";
const style = styleBlock("date-input");
const DateInput = props => {
    var _a, _b, _c;
    const [day, setDay] = useState(undefined);
    const [month, setMonth] = useState(undefined);
    const [year, setYear] = useState(undefined);
    useEffect(() => {
        var _a, _b;
        if (props.value && isNaN(props.value.valueOf())) {
            return;
        }
        setDay((_a = props.value) === null || _a === void 0 ? void 0 : _a.getDate());
        setMonth(props.value ? props.value.getMonth() + 1 : undefined);
        setYear((_b = props.value) === null || _b === void 0 ? void 0 : _b.getFullYear());
    }, [props.value]);
    const valueChanged = useCallback((e) => {
        var _a, _b;
        let dayValue = day;
        let monthValue = month;
        let yearValue = year;
        const datepart = e.target.dataset.datepart;
        switch (datepart) {
            case "day":
                dayValue = Number(e.target.value);
                setDay(dayValue);
                break;
            case "month":
                monthValue = Number(e.target.value);
                setMonth(monthValue);
                break;
            case "year":
                yearValue = Number(e.target.value);
                setYear(yearValue);
                break;
        }
        if (!dayValue && !monthValue && !yearValue) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, undefined);
            return;
        }
        const dateString = `${yearValue}/${monthValue}/${dayValue}`;
        const date = yearValue && yearValue > 1000 && monthValue && dayValue ? new Date(dateString) : new Date(NaN);
        (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, date);
    }, [day, month, year]);
    return (React.createElement("div", { className: style() },
        React.createElement(Form.Control, { className: style("day").toString(), placeholder: (_a = props.placeholder) === null || _a === void 0 ? void 0 : _a.day, type: "number", value: day || "", autoFocus: props.autoFocus, onChange: valueChanged, "data-datepart": "day", min: 1, max: 31, isInvalid: props.isInvalid }),
        React.createElement(Form.Control, { className: style("month").toString(), placeholder: (_b = props.placeholder) === null || _b === void 0 ? void 0 : _b.month, type: "number", value: month || "", onChange: valueChanged, "data-datepart": "month", min: 1, max: 12, isInvalid: props.isInvalid }),
        React.createElement(Form.Control, { className: style("year").toString(), placeholder: (_c = props.placeholder) === null || _c === void 0 ? void 0 : _c.year, type: "number", value: year || "", onChange: valueChanged, "data-datepart": "year", min: 1900, max: 2050, isInvalid: props.isInvalid })));
};
DateInput.defaultProps = {
    placeholder: { day: "Den", month: "Měsíc", year: "Rok" },
};
export default DateInput;
//# sourceMappingURL=index.js.map